import { Grid, Stack } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";

type Props = {
  children?: JSX.Element | JSX.Element[];
  csv_file_name?: string;
};

const UcDgvCustomToolbar = ({ children, csv_file_name, ...props }: Props) => {
  const showToolbar = true;

  return (
    <div>
      <Grid
        container
        item
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          {showToolbar === true ? (
            <GridToolbarContainer>
              <GridToolbarColumnsButton
                sx={{ paddingLeft: 2, color: "#AAAAAA" }}
              />
              <GridToolbarFilterButton
                sx={{ paddingLeft: 2, color: "#AAAAAA" }}
              />
              <GridToolbarDensitySelector
                sx={{ paddingLeft: 2, color: "#AAAAAA" }}
              />
              <GridToolbarExport
                sx={{ paddingLeft: 2, color: "#AAAAAA" }}
                csvOptions={{
                  fileName: csv_file_name,
                  utf8WithBom: true,
                }}
              />
            </GridToolbarContainer>
          ) : undefined}
        </Grid>

        <Grid item>
          <Stack direction="row" spacing={0}>
            {children}
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default UcDgvCustomToolbar;
